<div class="row">
  <div class="col-8">
    <h3 style="text-align: right;">Cash Receipt Preview</h3>
  </div>
  <div class="col" style="text-align: right;">
    <button mat-raised-button (click)="closeComponent()" style="color: white; background: red;">CLOSE</button>
  </div>
</div><br>
<div class="row">
  <div class="col">
    <iframe style="width: 100%; height: 600px;" [src]="pdf_data" width="100%" height="70%" *ngIf="pdf_data !== null"></iframe>
  </div>
</div>

